import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { useDispatch } from "react-redux";
import { closeModal } from "@/src_new/shared/redux/reducers/uiSlice";
import { usePosterReducers } from "@/src_new/shared/redux/store/useGetData";
import FormLayout from "@/src_new/shared/legacy/components/ui/FormLayout";
import { X } from "lucide-react";

const Modal = () => {
  const {
    ui: { status, name, title, children, className, header, outerClassName, form },
  } = usePosterReducers();
  const onSubmit = form?.onSubmit;
  const defaultValues = form?.defaultValues;
  const submitText = form?.submitText;
  const dispatch = useDispatch();
  if (status === "hide") return null;
  const isForm = typeof onSubmit === "function";

  // ESC close
  //   useEffect(() => {
  //     const handleEsc = (e: KeyboardEvent) => {
  //       if (e.key === "Escape") {
  //         onClose(name);
  //       }
  //     };
  //     document.addEventListener("keydown", handleEsc);
  //     return () => document.removeEventListener("keydown", handleEsc);
  //   }, [onClose, name]);

  return ReactDOM.createPortal(
    <div id={`modal-${name}`} className="fixed inset-0 z-50" data-modal-name={name}>
      {/* Backdrop */}
      <div
        className={`absolute inset-0 bg-black/10 backdrop-blur-sm `}
        onClick={() => dispatch(closeModal())}
      />

      {/* Modal Wrapper */}
      <div className={`relative flex min-h-screen justify-center items-center ${outerClassName}`}>
        <div
          className={`w-full max-h-[90vh] bg-white shadow-xl rounded-2xl flex flex-col animate-in fade-in zoom-in-95 p-3 ${className}`}
        >
          {/* Header */}
          <div className="flex items-center justify-between px-5 mt-2 flex-shrink-0">
            <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
            {header && <div>{header}</div>}
            <button
              onClick={() => dispatch(closeModal())}
              aria-label="Close"
              className="cursor-pointer text-gray-400 transition-all duration-200 ease-in-out hover:text-theme-danger hover:scale-110 hover:rotate-90 active:scale-95"
            >
              <X className="h-6 w-6" />
            </button>
          </div>

          {/* Body */}
          {isForm ? (
            <FormLayout submitText={submitText} defaultValues={defaultValues} onSubmit={onSubmit}>
              <div className="px-5 py-4 text-gray-700 overflow-y-auto thin-scrollbar flex-1 min-h-0">
                {children}
              </div>
            </FormLayout>
          ) : (
            <div className="px-3 py-2 text-gray-700 overflow-y-auto thin-scrollbar flex-1 min-h-0">
              {children}
            </div>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;
